import { message } from 'antd'

const imageDownloader = (imageUrl, fileName) => {
  fetch(imageUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]))
      const a = document.createElement('a')
      a.href = url
      a.download = `${fileName}`
      a.click()
      window.URL.revokeObjectURL(url)
    })
    .catch((error) => {
      message.error('Lỗi khi tải ảnh')
      console.error('Error downloading image:', error)
    })
}

export default imageDownloader
